var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEasterMarkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 20.0556C22 21.4055 20.9055 22.5 19.5556 22.5H2.44444C1.0945 22.5 0 21.4055 0 20.0556V2.94444C0 1.5945 1.0945 0.5 2.44444 0.5H19.5556C20.9055 0.5 22 1.5945 22 2.94444V20.0556Z",
    fill: "#77B255"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8922 4.38685C17.1858 3.92791 16.2398 4.12896 15.779 4.83663L9.12643 15.0905L6.05315 12.2488C5.43349 11.6756 4.46671 11.7141 3.8941 12.3331C3.32149 12.9528 3.35938 13.9196 3.97904 14.4922L8.38454 18.5658C8.67788 18.8378 9.05065 18.9722 9.42099 18.9722C9.83227 18.9722 10.3584 18.7999 10.7037 18.2762C10.9066 17.967 18.3426 6.50007 18.3426 6.50007C18.8015 5.79179 18.5999 4.84579 17.8922 4.38685Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasterMarkIcon);
export default __webpack_public_path__ + "static/media/EasterMarkIcon.db667565471b1cb9ea43f123fd7545c8.svg";
export { ForwardRef as ReactComponent };